var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomFeed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 60 60",
    fill: "#260e00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M71.3605,56.551H28.2277c-.9395,0-1.7012-.7617-1.7012-1.7012s.7617-1.7012,1.7012-1.7012h43.1328c.9395,0,1.7012.7617,1.7012,1.7012s-.7617,1.7012-1.7012,1.7012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3605,66.1946H28.2277c-.9395,0-1.7012-.7617-1.7012-1.7012s.7617-1.7012,1.7012-1.7012h43.1328c.9395,0,1.7012.7617,1.7012,1.7012s-.7617,1.7012-1.7012,1.7012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4221,75.8381h-27.1943c-.9395,0-1.7012-.7617-1.7012-1.7012s.7617-1.7012,1.7012-1.7012h27.1943c.9395,0,1.7012.7617,1.7012,1.7012s-.7617,1.7012-1.7012,1.7012Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.9484,46.6741H29.0519c-1.3926,0-2.5254-1.1328-2.5254-2.5254v-17.4609c0-1.3926,1.1328-2.5254,2.5254-2.5254h41.8965c1.3926,0,2.5254,1.1328,2.5254,2.5254v17.4609c0,1.3926-1.1328,2.5254-2.5254,2.5254ZM29.9289,43.2717h40.1426v-15.707H29.9289v15.707Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomFeed);
export default __webpack_public_path__ + "static/media/custom_feed.811946875f90da4291c43cf9fed906e0.svg";
export { ForwardRef as ReactComponent };